<template>
    <div>
    <!--  -->
    <!--  -->
      <div class="">
        <h1 class="titlequestion ">{{$t('renterms.title')}}</h1>
        <br><br>
        <div class=" navtext2 ">
        <!--  -->
          <p class="titleterm ">{{$t('renterms.Charges')}}</p>
          <li>{{$t('renterms.ch1')}}</li>
          <li>{{$t('renterms.ch2')}}</li>
          <li>{{$t('renterms.ch3')}}</li>
        <!--  --> <br>
          <p class="titleterm ">{{$t('renterms.basic_charge')}}</p>
          <li>{{$t('renterms.basic1')}}
           <ul>
               <li>{{$t('renterms.basic2')}}</li>
               <li>{{$t('renterms.basic3')}}</li>
               <li>{{$t('renterms.basic4')}}</li>
           </ul>
          </li>
          
        <!--  -->
          <p class="titleterm ">{{$t('renterms.add_charge')}}</p>
          <li>{{$t('renterms.edd')}} 
              <b-badge href="#" variant="success"
              v-b-tooltip.hover :title="$t('renterms.clp')"
              >?</b-badge>
          </li>
          <li>{{$t('renterms.cap')}} 
              <b-badge href="#" variant="success"
              v-b-tooltip.hover :title="$t('renterms.srd')"
              >?</b-badge>
          </li>
          <li>{{$t('renterms.alt')}}
              <b-badge href="#" variant="success"
              v-b-tooltip.hover :title="$t('renterms.rap')"
              >?</b-badge>
          </li>
          <li>{{$t('renterms.edd_tip')}} 
              <b-badge href="#" variant="success"
              v-b-tooltip.hover :title="$t('renterms.clp_tip')"
              >?</b-badge>
          </li>
          <li>{{$t('renterms.cap_tip')}}
              <b-badge href="#" variant="success"
              v-b-tooltip.hover :title="$t('renterms.srd_tip')"
              >?</b-badge>
          </li>
          <li>{{$t('renterms.alt_tip')}}
              <b-badge href="#" variant="success"
              v-b-tooltip.hover :title="$t('renterms.rap_tip')"
              >?</b-badge>
          </li>
        <!--  --> <br>
          <p class="titleterm ">{{$t('renterms.require')}}</p>
          <li>{{$t('renterms.req1')}}</li>
          <li>{{$t('renterms.req2')}}</li>
          <li>{{$t('renterms.req3')}}</li>
          <li>{{$t('renterms.req4')}}</li>
        <!--  --> <br>
          <p class="titleterm ">{{$t('renterms.warranty')}}</p>
          <li>{{$t('renterms.warr')}}</li>
          <li>{{$t('renterms.warr1')}}</li>
        <!--  --> <br>
          <p class="titleterm ">{{$t('renterms.warr2')}}</p>
          <li>{{$t('renterms.warr3')}}</li>
          <li>{{$t('renterms.warr4')}}</li>
          <li>{{$t('renterms.warr5')}}</li>
          <li>{{$t('renterms.warr6')}}</li>
        <!--  --> <br>
          <p class="titleterm ">{{$t('renterms.warr7')}}</p>
          <li>{{$t('renterms.warr8')}}</li>
        <!--  --> <br>
          <p class="titleterm ">{{$t('renterms.warr9')}}</p>
          <li>{{$t('renterms.warr10')}}</li>
        </div>
        <br><br>
       </div>  
      <!--  -->
    </div>
</template>
<script>

export default {
    name: 'renttermscomp'
}
</script>

<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.supportside{
  background-color: rgb(235, 235, 235);
  
}
.listgroup{
  border-top: none;
  border-left: none;
  border-right: none;
}
.supporticons{
    height: 50px;
    width: 50px;
    margin-bottom: 15px;
    margin-top: 30px;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   
   color: #333333;
   font-weight: 600;
   margin-bottom: 15px;
}
.titlesupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.textsupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  Height: 33px;
  border: none;
}
.button:hover{
  Background:#006639;
}
.noline{
  text-decoration: none;
}
</style>

